import './auth.scss';

import { useCallback, useEffect } from 'react';
import { Route, Routes, useMatch, useNavigate } from 'react-router-dom';

import { useAppContext } from '../../../data/context/app-context';
import { Button, ButtonType } from '../../../elements/button/button';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { Version } from '../../../elements/utils/version/version';
import { AuthStatus } from '../../../firebase/authentication';
import { ForgotPassword } from '../forgot-password/forgot-password';
import { Login } from '../login/login';
import { PinCode } from '../pincode/pincode';
import { ResetPassword } from '../reset-password/reset-password';

export function Auth() {
  const { authUser, status, signOut, validating } = useAppContext();

  const navigate = useNavigate();
  const isPasswordForgot = useMatch('/password-forgot');
  const isPasswordReset = useMatch('/password-reset');

  useEffect(() => {
    if (!validating && !isPasswordForgot && !isPasswordReset) {
      navigate(
        status?.status === AuthStatus.PINCODE ||
          status?.status === AuthStatus.UNVERIFIED
          ? '/pincode'
          : '/'
      );
    }
  }, [status, navigate, isPasswordForgot, isPasswordReset, validating]);

  const onHandleLogout = useCallback(() => {
    signOut();
  }, [signOut]);

  return (
    <div className="auth">
      <div className="auth__content">
        <span className="logo">
          <img src="/interface/img/doccs-logo.svg" alt="Doccs" />
        </span>

        <Routes>
          <Route path="pincode" element={<PinCode />} />
          <Route path="password-forgot" element={<ForgotPassword />} />
          <Route path="password-reset" element={<ResetPassword />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </div>
      <div className="auth__footer">
        <Version />
      </div>

      {authUser && (
        <div className="auth__buttons">
          <Button
            inverted
            type={ButtonType.SECONDARY_WHITE}
            onClick={onHandleLogout}
          >
            <CustomFormattedMessage id="common.logout" />
          </Button>
        </div>
      )}
    </div>
  );
}
